import { render, staticRenderFns } from "./ComboboxMunicipio.vue?vue&type=template&id=2cc5caa5"
import script from "./ComboboxMunicipio.vue?vue&type=script&lang=js"
export * from "./ComboboxMunicipio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports